var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('span',{staticClass:"loading__icon"},[_c('svg',{attrs:{"viewBox":"0 0 50 50"}},[_c('use',{attrs:{"xlink:href":"#icon--logo-e","width":"100%","height":"100%"}})])]),_c('span',{staticClass:"loading__label"},[_vm._v(" Loading... ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }